import { Button, TextField, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import moduleRoutes from "../../routes/moduleRouteList";
// import authenticationRouteList from "../routeList";
function ForgotPassword() {
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm();

  const onSubmit = (value: any) => {
    console.log(value);
  };
  return (
    <div className="flex justify-center items-center h-full ">
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="flex flex-col  w-[25vw] gap-5"
      >
        <Typography
          sx={{
            fontSize: " 1.60rem",
            fontWeight: "700!important",
            color: "#67666e",
            textAlign: "center",
          }}
          variant="h1"
        >
          Forgot password ?
        </Typography>
        <Typography sx={{ color: "#67666e" }} className="py-6">
          Enter the email address associated with your account and we'll send
          you a link to reset your password
        </Typography>
        <TextField
          type="email"
          InputProps={{
            sx: {
              borderRadius: "1.2rem",
            },
          }}
          style={{ width: "100%" }}
          label="Email"
          {...register("email", { required: "Email required" })}
          error={!!errors.email}
          // helperText={errors?.email?.message ? errors?.email?.message : ""}
          helperText={""}
        />
        <Button
          sx={{
            width: "100%",
            backgroundColor: "#0B3866",
            padding: "1vh",
            borderRadius: "1.2rem",
          }}
          type="submit"
          variant="contained"
        >
          continue
        </Button>
        <Link
          to={`/${moduleRoutes.authentication}`}
          className="bg-transparent p-2 ring-offset-0 text-sky-600 text-center"
        >
          Back to login
        </Link>
      </form>
    </div>
  );
}

export default ForgotPassword;
